import React, { Component } from 'react';
import { InputAdornment, MenuItem, TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import ArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import PhoneIcon from '@material-ui/icons/Phone';
import Done from '@material-ui/icons/Done';
import ReactPixel from 'react-facebook-pixel';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import Cartitem from './Cartitem';
import './Checkout.css';
import strings from './components/language/language';
import LoyaltyItem from './components/LoyaltyItem';
import LoyaltyItemDisabled from './components/LoyaltyItemDisabled';
import { DesktopContext } from './DesktopContext';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { string } from 'prop-types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormLabel from '@material-ui/core/FormLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckIcon from '@material-ui/icons/Check';
import RestaurantMenu from '@material-ui/icons/RestaurantMenu';

const styles = (theme) => ({
  formLabel: {
    fontSize: '13px',
    //marginLeft: '10px',
    //marginTop: '-3px',
    //fontFamily: 'helveticaRoman'
  },
  appartment: {
    // marginTop: '-8px',
  },
  orderNow: {
    color: '#fff',
    backgroundColor: '#70142c',
    border: '1px solid #70142c',
    fontSize: 16,
    height: 55,
    textTransform: 'capitalize',
    borderRadius: 28,
    bottom: -15,
    margin: 'auto',
    maxWidth: '90%',
    width: '100%',
    boxShadow: 'none',
    textTransform: 'capitalize',
    left: 0,
    right: 0,
    [theme.breakpoints.up('md')]: {
      width: '30%',
      left: '33% !important',
    },
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      left: '8% !important',
    },
  },
  backButton: {
    bottom: 5,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#998d9059',
    },
  },
  methodTitle: {
    marginBottom: 10,
    color: '#000',
    fontWeight: 'bold',
  },
  pickUp: {
    margin: '20px 15px 30px',
  },
  promoCodePrice: {
    marginLeft: 10,
  },
  addressNoteContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  addressNote: {
    color: '#06b706',
    padding: '5px 8px',
    borderRadius: 10,
    border: '1px solid #06b706',
  },
  checked: {
    color: '#70142c !important',
  },
  bar: {
    backgroundColor: '#70142c !important',
  },
  wrapper: {
    position: 'relative',
  },
  successWrapper: {
    position: 'relative',
    left: '46%',
    [theme.breakpoints.down('xs')]: {
      left: '38% !important',
    },
  },
  fabProgress: {
    color: '#4caf50',
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  disabledButton: {
    color: '#fff !important',
  },
});

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
    this.myRef = React.createRef();
    // console.log('props' + this.props.minimum);
    console.log('promoCap' + this.props.promoCap);
    let final_total = this.props.hasVat
      ? (this.props.total + this.props.delivery_fees) * 1.14
      : this.props.total + this.props.delivery_fees;

    let final_total_no_fees = this.props.hasVat
      ? this.props.total * 1.14
      : this.props.total;

    this.state = {
      chooseMethod: 'delivery',
      wholeAddress: this.props.wholeAddress || [],
      allNumbers: this.props.allNumbers || [],
      name: this.props.user_address,
      phone: this.props.user_phone,
      type: 'delivery',
      fetarTime: 'fetar',
      buildingNo: this.props.building,
      floorNo: this.props.floor,
      directions: this.props.directions,
      notes: this.props.notes,
      total: Number(final_total.toFixed(2)),
      total_no_fees: Number(final_total_no_fees.toFixed(2)),
      appartmentNo: this.props.appartmentNo,
      phone_id: '',
      address_id: '',
      button_disabled: false,
      first_name: this.props.first_name || '',
      open: false,
      freeOpen: false,
      minimum: this.props.minimum,
      minimum_free_item: this.props.minimum_free_item,
      firstOrder: this.props.isFirstOrder,
      free: this.props.freeItemFlag,
      branch_name: this.props.branch_name,
      branch_id: this.props.branch_id,
      loading: false,
      lastLoading: false,
      success: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.validateInputPickUp = this.validateInputPickUp.bind(this);
    this.Submit = this.Submit.bind(this);
    this.handleSnackbarClose = this.handleSnackbarClose.bind(this);
    this.handleSnackbarfreeClose = this.handleSnackbarfreeClose.bind(this);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  //! check method & type
  handleOrderType = (event) => {
    this.setState({
      chooseMethod: event.target.value,
      type: event.target.value,
    });
  };

  handleBranchChange = (e) => {
    const currentBranch = this.props.branches.find(
      (branch) => branch.label === e.target.value
    );
    this.setState({
      branch_name: e.target.value,
      branch_id: currentBranch.branch_id,
    });
  };

  static contextType = DesktopContext;

  componentDidMount() {
    window.scrollTo(0, this.myRef.current.offsetTop);
    // console.log('checkout -' + this.props.freeItemFlag + 'ss');
    if (this.state.free) {
      if (
        this.state.free &&
        this.state.total < this.state.minimum_free_item &&
        this.state.firstOrder === true
      ) {
        this.setState({ freeOpen: true, firstOrder: false });
      }
    } else {
      this.setState({ firstOrder: false });
    }
  }

  componentDidUpdate(props, prevState) {
    if (prevState.phone_id !== this.state.phone_id) {
      this.state.allNumbers.forEach((number, index) => {
        if (index === this.state.phone_id) {
          this.setState({ phone: number.phone });
        }
      });
    }

    if (prevState.address_id !== this.state.address_id) {
      this.state.wholeAddress.forEach((address, index) => {
        if (index === this.state.address_id) {
          this.setState({
            name: address.address,
            appartmentNo: address.appartmentNo,
            buildingNo: address.buildingNo,
            directions: address.directions,
            notes: address.notes,
            floorNo: address.floorNo,
          });
        }
      });
    }
  }

  validateInput() {
    let isFormValid = true;
    // Check for address
    if (this.state.name === '') {
      this.setState({
        nameError: true,
        nameErrorMessage: 'Address Can not be empty',
      });
      isFormValid = false;
    } else {
      this.setState({
        nameError: false,
        nameErrorMessage: '',
      });
    }
    // Check for phone number
    if (this.state.phone === '') {
      this.setState({
        phoneError: true,
        phoneErrorMessage: 'Phone Can not be empty',
      });
      isFormValid = false;
    } else if (this.state.phone.length > 12) {
      this.setState({
        phoneError: true,
        phoneErrorMessage: 'Phone Can not be longer than 12 digits',
      });
      isFormValid = false;
    } else {
      this.setState({
        phoneError: false,
        phoneErrorMessage: '',
      });
    }
    // Check for floor no.
    if (this.state.floorNo === '') {
      this.setState({
        floorError: true,
        floorErrorMessage: 'Floor can not be empty',
      });
      isFormValid = false;
    } else {
      this.setState({
        floorError: false,
        floorErrorMessage: '',
      });
    }
    // Check for Building No.
    if (this.state.buildingNo === '') {
      this.setState({
        buildingError: true,
        buildingErrorMessage: 'Building can not be empty',
      });
      isFormValid = false;
    } else {
      this.setState({
        buildingError: false,
        buildingErrorMessage: '',
      });
    }
    //  Check for Appartment No.
    if (this.state.appartmentNo === '') {
      this.setState({
        appartmentError: true,
        appartmentErrorMessage: 'Appartment Number can not be empty',
      });
      isFormValid = false;
    } else {
      this.setState({
        appartmentError: false,
        appartmentErrorMessage: '',
      });
    }

    // checking order minimum value
    if (this.state.total < this.state.minimum) {
      this.setState({
        open: true,
      });
      isFormValid = false;
    }

    if (isFormValid && !this.state.loading) {
      this.setState(
        {
          success: false,
          button_disabled: true,
          loading: true,
          lastLoading: true,
        },
        () => {
          this.timer = setTimeout(() => {
            this.setState({
              loading: false,
              success: true,
              nameError: false,
              phoneError: false,
              floorError: false,
              buildingError: false,
              appartmentError: false,
              nameErrorMessage: '',
              phoneErrorMessage: '',
              floorErrorMessage: '',
              buildingErrorMessage: '',
              appartmentErrorMessage: '',
            });

            // Add to wholeAddress array
            let arr = [...this.state.wholeAddress];
            let addressFound = false;

            const address = {
              address: this.state.name,
              buildingNo: this.state.buildingNo,
              floorNo: this.state.floorNo,
              appartmentNo: this.state.appartmentNo,
              directions: this.state.directions,
              notes: this.state.notes,
            };

            // Add if first address
            if (arr.length === 0) {
              arr.push(address);
              this.setState({ wholeAddress: arr });
            }

            // check if address already exists
            arr.forEach((address) => {
              if (address.address === this.state.name) {
                addressFound = true;
              }
            });

            // if address is not found push
            if (!addressFound) {
              arr.push(address);
              this.setState({ wholeAddress: arr });
            }

            // Add to allNumbers array
            let numbers = [...this.state.allNumbers];
            let numberFound = false;

            // Add to phone array if first number
            if (numbers.length === 0) {
              numbers.push({ phone: this.state.phone });
              this.setState({ allNumbers: numbers });
            }

            // Check if number already exits
            numbers.forEach((number) => {
              if (this.state.phone === number.phone) {
                numberFound = true;
              }
            });

            // If number is not found push
            if (!numberFound) {
              numbers.push({ phone: this.state.phone });
              this.setState({ allNumbers: numbers });
            }

            this.setState({ isFormValid: isFormValid }, this.Submit);
          }, 1000);
        }
      );
    }
  }

  validateInputPickUp() {
    let isFormValid = true;
    // Check for phone number
    if (this.state.phone === '') {
      this.setState({
        phoneError: true,
        phoneErrorMessage: 'Phone Can not be empty',
      });
      isFormValid = false;
    } else if (this.state.phone.length > 12) {
      this.setState({
        phoneError: true,
        phoneErrorMessage: 'Phone Can not be longer than 12 digits',
      });
      isFormValid = false;
    } else {
      this.setState({
        phoneError: false,
        phoneErrorMessage: '',
      });
    }

    if (isFormValid && !this.state.loading) {
      this.setState(
        {
          success: false,
          button_disabled: true,
          loading: true,
          lastLoading: true,
        },
        () => {
          this.timer = setTimeout(() => {
            this.setState({
              loading: false,
              success: true,
              nameError: false,
              phoneError: false,
            });
            this.setState({ isFormValid: isFormValid }, this.Submit);
          }, 1000);
        }
      );
    }
  }
  //buildingNo,floorNo,appartmentNo,landmark
  Submit() {
    if (this.state.isFormValid) {
      // this.props.submit_order(this.state.name,this.state.phone,this.state.streetName,this.state.buildingNo,this.state.floorNo,this.state.appartmentNo,this.state.landmark)
      //this.state.phone,this.state.name
      this.props.submit_order(
        this.state.phone,
        this.state.name,
        this.state.buildingNo,
        this.state.floorNo,
        this.state.directions,
        this.state.notes,
        this.state.appartmentNo,
        this.state.allNumbers,
        this.state.wholeAddress,
        this.props.delivery_fees,
        this.state.first_name,
        this.state.type,
        this.props.fetarOrASAP ? this.state.fetarTime : null,
        this.state.branch_name,
        this.state.branch_id
      );

      // if (this.state.chooseMethod === 'delivery') {
      //   this.setState({ type: 'delivery' });
      // } else {
      //   this.setState({ type: 'pickUp' });
      // }

      // this.setState({ button_disabled: true });

      ReactPixel.trackCustom(
        `desktop - ${this.props.restaurant_name} - submit order`,
        {
          userID: this.props.messenger_user_id,
        }
      );
      ReactPixel.trackCustom('desktop - Submit_order');

      // window.location.href="https://www.messenger.com/closeWindow/?image_url=https://en.facebookbrand.com/wp-content/uploads/2016/09/messenger_icon2.png&display_text=redirecting";
    }

    //chatbot opt-in
    // if (this.props.desktop) {
    //   window.confirmOptIn();
    // }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSnackbarClose() {
    this.setState({
      open: false,
    });
  }

  handleSnackbarfreeClose() {
    this.setState({
      freeOpen: false,
    });
  }

  handleFetarTime = (event) => {
    this.setState({
      fetarTime: event.target.value,
    });
  };

  render() {
    const pageID = this.props.desktopInfo.page_id;
    const messengerAppID = this.props.desktopInfo.messenger_app_id;

    const { classes, promoCode } = this.props;

    console.log('total', this.props.total);

    // promo code for order item price
    const promoCodeDiscountOrder = (this.props.total / 100) * promoCode;

    const promoCodeDiscountOrder2 = promoCodeDiscountOrder.toFixed(2);

    // promo code for total price (no fees)
    let promoCodeDiscountTotalNoFees;

    let promoCodeTotalNoFees;
    let promoCodeVat = 0;
    let promoCodeVatPickUp = 0;
    let promoTotalPickUpWithVat = 0;
    let promoCodeTotalWithDelivreyTax = 0;
    let totalWithoutVat = 0;

    //cechk if it under promoCode cap
    if (this.props.total - promoCodeDiscountOrder > this.props.promoCap) {
      let totalCap = this.props.total - this.props.promoCap;
      console.log('totalCap', totalCap);
      promoCodeVat = Number(
        (totalCap + this.props.delivery_fees) * 0.14
      ).toFixed(2);
      console.log('promoCodeVat', promoCodeVat);

      console.log('cap required');
      promoCodeTotalWithDelivreyTax =
        Number(this.props.total - this.props.promoCap) +
        Number(this.props.delivery_fees) +
        Number(promoCodeVat);

      promoCodeVatPickUp = Number(totalCap * 0.14).toFixed(2);
      promoTotalPickUpWithVat = Number(totalCap) + Number(promoCodeVatPickUp);

      totalWithoutVat = Number(totalCap + this.props.delivery_fees);
      console.log('totalWithoutVat' + totalWithoutVat);

      promoCodeTotalNoFees = totalCap;
    } else {
      console.log('No cap');
      //delivery start
      promoCodeVat = Number(
        (promoCodeDiscountOrder + this.props.delivery_fees) * 0.14
      ).toFixed(2);

      promoCodeTotalWithDelivreyTax =
        Number(promoCodeDiscountOrder2) +
        Number(this.props.delivery_fees) +
        Number(promoCodeVat);

      //delivery end

      //PickUp start
      promoCodeVatPickUp = Number(promoCodeDiscountOrder * 0.14).toFixed(2);
      promoTotalPickUpWithVat =
        Number(promoCodeDiscountOrder) + Number(promoCodeVatPickUp);
      //PickUp end

      totalWithoutVat = Number(
        promoCodeDiscountOrder + this.props.delivery_fees
      );

      // promo code for total price (no fees)
      promoCodeDiscountTotalNoFees =
        (this.state.total_no_fees / 100) * promoCode;

      promoCodeTotalNoFees =
        this.state.total_no_fees - promoCodeDiscountTotalNoFees;
    }

    // const { expanded } = this.state;
    let redeemable_items = this.props.redeemableItems
      ? this.props.redeemableItems.map((item, index) => {
          let price = 0;
          if (typeof item.price === 'object') {
            //find the smallest price

            Object.keys(item.price).forEach((size) => {
              if (price === 0) price = item.price[size];
              else if (price > item.price[size]) price = item.price[size];
            });
          } else {
            price = item.price;
          }

          if (price * 10 > this.props.user_points) {
            return <LoyaltyItemDisabled name={item.name} />;
          } else {
            return (
              <LoyaltyItem
                redeem={() => this.props.redeem(index)}
                name={item.name}
              />
            );
          }
        })
      : null;
    return (
      <div>
        {this.props.desktop && (
          <Helmet>
            <script>{`window.fbMessengerPlugins = window.fbMessengerPlugins || { init : function() { FB.init({ appId: ${messengerAppID}, xfbml: true, version: "v3.0" }); }, callable : [] }; window.fbMessengerPlugins.callable.push( function() { var ruuid, fbPluginElements = document.querySelectorAll(".fb-messenger-checkbox[page_id='${pageID}']"); if (fbPluginElements) { for( i = 0; i < fbPluginElements.length; i++ ) { ruuid = 'cf_' + (new Array(16).join().replace(/(.|$)/g, function(){return ((Math.random()*36)|0).toString(36)[Math.random()<.5?"toString":"toUpperCase"]();})); fbPluginElements[i].setAttribute('user_ref', ruuid) ; fbPluginElements[i].setAttribute('origin', window.location.href); window.confirmOptIn = function() { FB.AppEvents.logEvent('MessengerCheckboxUserConfirmation', null, { app_id:${messengerAppID}, page_id:${pageID}, ref:"b64:dGVzdA==", user_ref: ruuid }); }; } } }); window.fbAsyncInit = window.fbAsyncInit || function() { window.fbMessengerPlugins.callable.forEach( function( item ) { item(); } ); window.fbMessengerPlugins.init(); }; setTimeout( function() { (function(d, s, id){ var js, fjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) { return; } js = d.createElement(s); js.id = id; js.src = "//connect.facebook.net/en_US/sdk.js"; fjs.parentNode.insertBefore(js, fjs); }(document, 'script', 'facebook-jssdk')); }, 0);`}</script>
          </Helmet>
        )}

        {/* <button onClick={()=>this.add_points(1)}>press me</button> */}
        <div id='checkout-header' style={{ backgroundColor: this.props.color }}>
          {/* <NavLink to="/">
					<Icon id="back-icon">arrow_back_ios</Icon>
					</NavLink> */}

          <NavLink to='/order' style={{ textDecoration: 'none' }}>
            <Button className={classes.backButton}>
              <ArrowLeft /> {strings.back}
            </Button>
          </NavLink>

          <NavLink
            to='/editcart'
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <div className=' right-align'>
              <Button
                className='edit-order-button'
                title='EditOrder'
                variant='outlined'
              >
                {strings.edit_order}
              </Button>
            </div>
          </NavLink>
        </div>
        {!this.props.hasRedeemed ? (
          <React.Fragment>
            {/* <span className="loyalty-title-span">Free Items</span> */}
            {/* <LoyaltySection
              expanded={this.props.expanded}
              expand={this.props.expand}
            />

            <div className='loyalty-container'>
              <Collapse in={this.props.expanded}>
                <LoyaltyPoints points={this.props.user_points} /> */}
            {/* <LoyaltyItem/>
                    <LoyaltyItemDisabled />
                    <LoyaltyItemDisabled/>
                    <LoyaltyItemDisabled/> */}
            {/* <div className='redeemable-items-container'>
                  {redeemable_items}
                </div>
              </Collapse>
            </div> */}
          </React.Fragment>
        ) : null}
        <div className='checkout'>
          {/* <NavLink to="/editcart" style={{ textDecoration: 'none' ,color: 'inherit'}}> <Button className="edit-order-button">Edit Order</Button></NavLink> */}
          {/* order grid */}
          <Grid container spacing={16}>
            <Grid
              item
              md={6}
              xs={12}
              style={{
                position: 'relative',
                display: 'block',
                textAlign:
                  (this.props.lang === 'ar') | (this.props.lang === 'qrAR')
                    ? 'right'
                    : 'left',
              }}
            >
              <span className='title-span'>{strings.order}</span>
              <div className='row' id='order-details'>
                <CardContent id='items-card'>
                  {this.state.firstOrder && (
                    <Cartitem
                      freeItem={true}
                      price='free'
                      name={this.props.freeItem.name}
                      count='1'
                    />
                  )}
                  {this.props.cart.map((item, index) => {
                    return (
                      <Cartitem
                        price={item.price}
                        add_ons={item.add_ons}
                        name={item.name}
                        count={item.count}
                        size={item.size}
                        index={index}
                      />
                    );
                  })}
                </CardContent>

                <div id='recipt-container'>
                  <Grid container id='checkout-recipt' spacing={0}>
                    <Grid item id='order' xs={4}>
                      <span>{strings.order}</span>
                    </Grid>
                    <Grid item className='right-align-span' xs={8}>
                      <span>
                        {this.props.total} {strings.currency}
                      </span>
                    </Grid>
                  </Grid>
                  {this.props.pickUp && this.state.type === 'delivery' ? (
                    <Grid container id='checkout-recipt' spacing={0}>
                      <Grid item id='delivery' xs={4}>
                        <span>{strings.delivery}</span>
                      </Grid>
                      <Grid item className='right-align-span' xs={8}>
                        <span>
                          {this.props.delivery_fees} {strings.currency}
                        </span>
                      </Grid>
                    </Grid>
                  ) : this.props.pickUp &&
                    this.state.type === 'pickUp' ? null : (
                    <Grid container id='checkout-recipt' spacing={0}>
                      <Grid item id='delivery' xs={4}>
                        <span>{strings.delivery}</span>
                      </Grid>
                      <Grid item className='right-align-span' xs={8}>
                        <span>
                          {this.props.delivery_fees} {strings.currency}
                        </span>
                      </Grid>
                    </Grid>
                  )}
                  {this.props.hasVat ? (
                    <Grid container id='checkout-recipt' spacing={0}>
                      <Grid item id='delivery' xs={4}>
                        <span>VAT Taxes(14%) </span>
                      </Grid>
                      <Grid item className='right-align-span' xs={8}>
                        {promoCode ? (
                          this.props.pickUp && this.state.type === 'pickUp' ? (
                            <span>{Number(promoCodeVatPickUp).toFixed(2)}</span>
                          ) : (
                            <span>{promoCodeVat}</span>
                          )
                        ) : (
                          <span>
                            {Number(
                              (this.props.total + this.props.delivery_fees) *
                                0.14
                            ).toFixed(2)}
                          </span>
                        )}
                      </Grid>
                    </Grid>
                  ) : null}

                  <Grid container id='checkout-recipt' spacing={0}>
                    <Grid item id='checkout-total' xs={4}>
                      <span>{strings.total}</span>
                    </Grid>
                    <Grid item className='right-align-span' xs={8}>
                      {this.props.pickUp && this.state.type === 'delivery' ? (
                        <div>
                          <span
                            id='bold-total-check'
                            style={{
                              textDecoration: promoCode
                                ? 'line-through'
                                : 'none',
                              fontWeight: promoCode ? 'normal' : 600,
                            }}
                          >
                            {this.state.total} {strings.currency}
                          </span>
                          {promoCode && (
                            <span
                              className={classNames(
                                classes.promoCodePrice,
                                'promo-code-total'
                              )}
                            >
                              {this.props.hasVat ? (
                                <span
                                  className={classNames(
                                    classes.promoCodePrice,
                                    'promo-code-total'
                                  )}
                                >
                                  {promoCodeTotalWithDelivreyTax.toFixed(2)}{' '}
                                  {strings.currency}
                                </span>
                              ) : (
                                <span>
                                  {Number(totalWithoutVat).toFixed(2)}
                                </span>
                              )}
                            </span>
                          )}
                        </div>
                      ) : this.props.pickUp && this.state.type === 'pickUp' ? (
                        <div>
                          <span
                            id='bold-total-check'
                            style={{
                              textDecoration: promoCode
                                ? 'line-through'
                                : 'none',
                              fontWeight: promoCode ? 'normal' : 600,
                            }}
                          >
                            {this.state.total_no_fees} {strings.currency}
                          </span>
                          {promoCode &&
                            (this.props.hasVat ? (
                              <span
                                className={classNames(
                                  classes.promoCodePrice,
                                  'promo-code-total'
                                )}
                              >
                                {Number(promoTotalPickUpWithVat).toFixed(2)}{' '}
                                {strings.currency}
                              </span>
                            ) : (
                              <span
                                className={classNames(
                                  classes.promoCodePrice,
                                  'promo-code-total'
                                )}
                              >
                                {promoCodeTotalNoFees.toFixed(2)}{' '}
                                {strings.currency}
                              </span>
                            ))}
                        </div>
                      ) : (
                        <div>
                          <span
                            id='bold-total-check'
                            style={{
                              textDecoration: promoCode
                                ? 'line-through'
                                : 'none',
                              fontWeight: promoCode ? 'normal' : 600,
                            }}
                          >
                            {this.state.total} {strings.currency}
                          </span>
                          {promoCode && (
                            <span
                              className={classNames(
                                classes.promoCodePrice,
                                'promo-code-total'
                              )}
                            >
                              {promoCodeTotalWithDelivreyTax} {strings.currency}
                            </span>
                          )}
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </div>
              </div>
              {this.props.fetarOrASAP && (
                <div
                  className='method-container'
                  style={{
                    textAlign:
                      (this.props.lang === 'ar') | (this.props.lang === 'qrAR')
                        ? 'right '
                        : 'left ',
                  }}
                >
                  <FormControl component='fieldset'>
                    <FormLabel
                      component='legend'
                      className={classes.methodTitle}
                    >
                      {strings.choose_order_time}
                    </FormLabel>
                    <RadioGroup
                      defaultValue='fetar'
                      aria-label='fetar'
                      name='fetar'
                      value={this.state.fetarTime}
                      onChange={this.handleFetarTime}
                      className='radio-group'
                    >
                      <FormControlLabel
                        value='fetar'
                        control={
                          <Radio
                            style={{
                              color: this.props.color
                                ? this.props.color
                                : '#70142c',
                            }}
                          />
                        }
                        label={strings.fetarTime}
                      />
                      <FormControlLabel
                        value='ASAP'
                        control={
                          <Radio
                            style={{
                              color: this.props.color
                                ? this.props.color
                                : '#70142c',
                            }}
                          />
                        }
                        label={strings.ASAP}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              )}
              {this.props.pickUp && (
                <div
                  className='method-container'
                  style={{
                    margin: this.props.fetarOrASAP
                      ? '25px 32px 10px 10px'
                      : '70px 32px 10px 10px',
                    textAlign:
                      (this.props.lang === 'ar') | (this.props.lang === 'qrAR')
                        ? 'right '
                        : 'left ',
                  }}
                >
                  <FormControl component='fieldset'>
                    <FormLabel
                      component='legend'
                      className={classes.methodTitle}
                    >
                      {strings.choose_method}
                    </FormLabel>
                    <RadioGroup
                      defaultValue='delivery'
                      aria-label='delivery'
                      name='delivery'
                      value={this.state.chooseMethod}
                      onChange={this.handleOrderType}
                      className='radio-group'
                    >
                      <FormControlLabel
                        value='delivery'
                        control={<Radio style={{ color: this.props.color }} />}
                        label={strings.delivery_method}
                      />
                      <FormControlLabel
                        value='pickUp'
                        control={<Radio style={{ color: this.props.color }} />}
                        label={strings.pick_up}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              )}
            </Grid>
            {this.props.pickUp === true &&
            this.state.chooseMethod === 'delivery' ? (
              <Grid item md={6} xs={12}>
                <div>
                  <div className='checkout-form-container'>
                    <div className={classes.addressNoteContainer}>
                      <span
                        style={{
                          fontSize: 20,
                          fontWeight: 'bold',
                          order:
                            (this.props.lang === 'ar') |
                            (this.props.lang === 'qrAR')
                              ? 1
                              : 0,
                        }}
                      >
                        {strings.delivery_method}
                      </span>
                      <div className={classes.addressNote}>
                        <span style={{ position: 'relative', bottom: 6 }}>
                          {strings.address_save}
                        </span>
                        <Done />
                      </div>
                    </div>
                    <div id='checkout-form' ref={this.myRef}>
                      {this.state.allNumbers.length > 1 ? (
                        <Grid container>
                          <Grid item xs={12}>
                            <TextField
                              select
                              label={strings.select_mobile_no}
                              onChange={this.handleInputChange}
                              margin='normal'
                              value={this.state.phone_id}
                              inputProps={{
                                style: {
                                  textAlign:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'right'
                                      : 'unset',
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  left:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'unset'
                                      : 0,
                                  right:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 0
                                      : 'unset',
                                },
                              }}
                              name='phone_id'
                              style={{ width: '100%' }}
                            >
                              {this.state.allNumbers.map((number, index) => (
                                <MenuItem key={index} value={index}>
                                  {number.phone}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                        </Grid>
                      ) : null}

                      <Grid container spacing={16}>
                        {this.props.desktop && (
                          <Grid item xs={6} style={{ marginTop: 5 }}>
                            <TextField
                              label={strings.name}
                              required={true}
                              onChange={this.handleInputChange}
                              margin='normal'
                              value={this.state.first_name}
                              inputProps={{
                                style: {
                                  textAlign:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'right'
                                      : 'unset',
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  left:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'unset'
                                      : 0,
                                  right:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 0
                                      : 'unset',
                                },
                              }}
                              name='first_name'
                              style={{ width: '100%' }}
                            />
                          </Grid>
                        )}
                        <Grid item xs={this.props.desktop ? 6 : 12}>
                          <TextField
                            name='phone'
                            id='error'
                            label={strings.phone}
                            multiline='false'
                            fullWidth
                            margin='normal'
                            type='number'
                            onChange={this.handleInputChange}
                            error={this.state.phoneError}
                            helperText={
                              this.state.phoneErrorMessage ||
                              strings.add_new_phone
                            }
                            value={this.state.phone}
                            className='validate'
                            inputProps={{
                              style: {
                                textAlign:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'right'
                                    : 'unset',
                              },
                            }}
                            InputLabelProps={{
                              className: classes.formLabel,
                              style: {
                                left:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'unset'
                                    : 0,
                                right:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 0
                                    : 'unset',
                              },
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  variant='filled'
                                  position='start'
                                >
                                  <PhoneIcon />
                                </InputAdornment>
                              ),
                            }}
                            onInput={(e) => {
                              // e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,12)
                              e.target.value = e.target.value.slice(0, 11);
                            }}
                          />
                        </Grid>
                      </Grid>
                      {this.state.wholeAddress.length > 1 ? (
                        <Grid container>
                          <Grid item xs={12}>
                            <TextField
                              select
                              label={strings.select_address}
                              onChange={this.handleInputChange}
                              margin='normal'
                              value={this.state.address_id}
                              name='address_id'
                              inputProps={{
                                style: {
                                  textAlign:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'right'
                                      : 'unset',
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  left:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'unset'
                                      : 0,
                                  right:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 0
                                      : 'unset',
                                },
                              }}
                              style={{ width: '100%' }}
                            >
                              {this.state.wholeAddress.map((address, index) => (
                                <MenuItem key={index} value={index}>
                                  {address.address}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                        </Grid>
                      ) : null}
                      <Grid container spacing={16}>
                        <Grid item xs={8}>
                          <TextField
                            name='name'
                            id='error'
                            label={strings.street_name}
                            multiline='false'
                            fullWidth
                            margin='normal'
                            onChange={this.handleInputChange}
                            error={this.state.nameError}
                            helperText={this.state.nameErrorMessage}
                            value={this.state.name}
                            className='validate'
                            inputProps={{
                              style: {
                                textAlign:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'right'
                                    : 'unset',
                              },
                            }}
                            InputLabelProps={{
                              className: classes.formLabel,
                              style: {
                                left:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'unset'
                                    : 0,
                                right:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 0
                                    : 'unset',
                              },
                            }}
                            style={{ marginBottom: '10px' }}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            name='buildingNo'
                            id='error'
                            label={strings.building}
                            multiline='false'
                            fullWidth
                            margin='normal'
                            onChange={this.handleInputChange}
                            error={this.state.buildingError}
                            helperText={this.state.buildingErrorMessage}
                            value={this.state.buildingNo}
                            inputProps={{
                              style: {
                                textAlign:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'right'
                                    : 'unset',
                              },
                            }}
                            InputLabelProps={{
                              style: {
                                left:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'unset'
                                    : 0,
                                right:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 0
                                    : 'unset',
                              },
                            }}
                            className='validate'
                            style={{ marginBottom: '10px' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={16}>
                        <Grid item xs={6}>
                          <TextField
                            name='floorNo'
                            id='error'
                            label={strings.floor}
                            multiline='false'
                            fullWidth
                            margin='normal'
                            onChange={this.handleInputChange}
                            error={this.state.floorError}
                            helperText={this.state.floorErrorMessage}
                            value={this.state.floorNo}
                            inputProps={{
                              style: {
                                textAlign:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'right'
                                    : 'unset',
                              },
                            }}
                            InputLabelProps={{
                              style: {
                                left:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'unset'
                                    : 0,
                                right:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 0
                                    : 'unset',
                              },
                            }}
                            className='validate'
                            style={{ marginBottom: '10px' }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            name='appartmentNo'
                            id='error'
                            label={strings.appartment_number}
                            multiline='false'
                            fullWidth
                            margin='normal'
                            onChange={this.handleInputChange}
                            error={this.state.appartmentError}
                            helperText={this.state.appartmentErrorMessage}
                            value={this.state.appartmentNo}
                            className='validate'
                            style={{ marginBottom: '10px' }}
                            inputProps={{
                              style: {
                                textAlign:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'right'
                                    : 'unset',
                              },
                            }}
                            InputLabelProps={{
                              style: {
                                left:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'unset'
                                    : 0,
                                right:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 0
                                    : 'unset',
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={12}>
                          <TextField
                            name='directions'
                            label={strings.directions}
                            multiline='false'
                            fullWidth
                            margin='normal'
                            onChange={this.handleInputChange}
                            value={this.state.directions}
                            inputProps={{
                              style: {
                                textAlign:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'right'
                                    : 'unset',
                              },
                            }}
                            InputLabelProps={{
                              style: {
                                left:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'unset'
                                    : 0,
                                right:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 0
                                    : 'unset',
                              },
                            }}
                            style={{ marginBottom: '30px' }}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                  <div
                    className='fb-messenger-checkbox'
                    origin=''
                    page_id={pageID}
                    messenger_app_id={messengerAppID}
                    user_ref=''
                    prechecked='true'
                    allow_login='true'
                    size='large'
                  />
                </div>
              </Grid>
            ) : this.props.pickUp === true &&
              this.state.chooseMethod === 'pickUp' ? (
              <Grid item md={6} xs={12}>
                <span style={{ fontSize: 20, fontWeight: 'bold' }}>
                  {strings.pick_up}
                </span>
                <div className={classes.pickUp}>
                  {this.props.desktop && (
                    <Grid item xs={12} style={{ marginTop: 5 }}>
                      <TextField
                        label={strings.name}
                        required={true}
                        onChange={this.handleInputChange}
                        margin='normal'
                        value={this.state.first_name}
                        inputProps={{
                          style: {
                            textAlign:
                              (this.props.lang === 'ar') |
                              (this.props.lang === 'qrAR')
                                ? 'right'
                                : 'unset',
                          },
                        }}
                        InputLabelProps={{
                          style: {
                            left:
                              (this.props.lang === 'ar') |
                              (this.props.lang === 'qrAR')
                                ? 'unset'
                                : 0,
                            right:
                              (this.props.lang === 'ar') |
                              (this.props.lang === 'qrAR')
                                ? 0
                                : 'unset',
                          },
                        }}
                        name='first_name'
                        style={{ width: '100%' }}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} style={{ marginBottom: 15 }}>
                    <TextField
                      name='phone'
                      id='error'
                      label={strings.phone}
                      multiline='false'
                      fullWidth
                      margin='normal'
                      type='number'
                      onChange={this.handleInputChange}
                      error={this.state.phoneError}
                      helperText={
                        this.state.phoneErrorMessage || strings.add_new_phone
                      }
                      value={this.state.phone}
                      className='validate'
                      inputProps={{
                        style: {
                          textAlign:
                            (this.props.lang === 'ar') |
                            (this.props.lang === 'qrAR')
                              ? 'right'
                              : 'unset',
                        },
                      }}
                      InputLabelProps={{
                        className: classes.formLabel,
                        style: {
                          left:
                            (this.props.lang === 'ar') |
                            (this.props.lang === 'qrAR')
                              ? 'unset'
                              : 0,
                          right:
                            (this.props.lang === 'ar') |
                            (this.props.lang === 'qrAR')
                              ? 0
                              : 'unset',
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment variant='filled' position='start'>
                            <PhoneIcon />
                          </InputAdornment>
                        ),
                      }}
                      onInput={(e) => {
                        // e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,12)
                        e.target.value = e.target.value.slice(0, 11);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ marginBottom: 15 }}>
                    <FormControl>
                      <InputLabel htmlFor='age-simple'>
                        {strings.choose_branch}
                      </InputLabel>
                      <Select
                        value={this.state.branch_name || ''}
                        style={{ width: 200 }}
                        onChange={this.handleBranchChange}
                      >
                        {this.props.branches.map((branch) => (
                          <MenuItem id={branch.label} value={branch.label}>
                            {branch.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} style={{ marginBottom: 15 }}>
                    <TextField
                      name='notes'
                      label={strings.additional_notes}
                      multiline='false'
                      inputProps={{
                        style: {
                          textAlign:
                            (this.props.lang === 'ar') |
                            (this.props.lang === 'qrAR')
                              ? 'right'
                              : 'unset',
                        },
                      }}
                      InputLabelProps={{
                        style: {
                          left:
                            (this.props.lang === 'ar') |
                            (this.props.lang === 'qrAR')
                              ? 'unset'
                              : 0,
                          right:
                            (this.props.lang === 'ar') |
                            (this.props.lang === 'qrAR')
                              ? 0
                              : 'unset',
                        },
                      }}
                      fullWidth
                      margin='normal'
                      onChange={this.handleInputChange}
                      value={this.state.notes}
                      style={{ marginBottom: '30px' }}
                    />
                  </Grid>
                </div>
              </Grid>
            ) : (
              <Grid item md={6} xs={12}>
                <div>
                  <div className='checkout-form-container'>
                    <span style={{ fontSize: 20, fontWeight: 'bold' }}>
                      {strings.delivery_method}
                    </span>
                    <div id='checkout-form' ref={this.myRef}>
                      {this.state.allNumbers.length > 1 ? (
                        <Grid container>
                          <Grid item xs={12}>
                            <TextField
                              select
                              label={strings.select_mobile_no}
                              onChange={this.handleInputChange}
                              margin='normal'
                              value={this.state.phone_id}
                              name='phone_id'
                              style={{ width: '100%' }}
                              inputProps={{
                                style: {
                                  textAlign:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'right'
                                      : 'unset',
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  left:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'unset'
                                      : 0,
                                  right:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 0
                                      : 'unset',
                                },
                              }}
                            >
                              {this.state.allNumbers.map((number, index) => (
                                <MenuItem key={index} value={index}>
                                  {number.phone}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                        </Grid>
                      ) : null}

                      <Grid container spacing={16}>
                        {this.props.desktop && (
                          <Grid item xs={6} style={{ marginTop: 5 }}>
                            <TextField
                              label={strings.name}
                              required={true}
                              onChange={this.handleInputChange}
                              margin='normal'
                              value={this.state.first_name}
                              inputProps={{
                                style: {
                                  textAlign:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'right'
                                      : 'unset',
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  left:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'unset'
                                      : 0,
                                  right:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 0
                                      : 'unset',
                                },
                              }}
                              name='first_name'
                              style={{ width: '100%' }}
                            />
                          </Grid>
                        )}
                        <Grid item xs={this.props.desktop ? 6 : 12}>
                          <TextField
                            name='phone'
                            id='error'
                            label={strings.phone}
                            multiline='false'
                            fullWidth
                            margin='normal'
                            type='number'
                            onChange={this.handleInputChange}
                            error={this.state.phoneError}
                            helperText={
                              this.state.phoneErrorMessage ||
                              strings.add_new_phone
                            }
                            value={this.state.phone}
                            className='validate'
                            inputProps={{
                              style: {
                                textAlign:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'right'
                                    : 'unset',
                              },
                            }}
                            InputLabelProps={{
                              className: classes.formLabel,
                              style: {
                                left:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'unset'
                                    : 0,
                                right:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 0
                                    : 'unset',
                              },
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  variant='filled'
                                  position='start'
                                >
                                  <PhoneIcon />
                                </InputAdornment>
                              ),
                            }}
                            onInput={(e) => {
                              // e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,12)
                              e.target.value = e.target.value.slice(0, 11);
                            }}
                          />
                        </Grid>
                      </Grid>
                      {this.state.wholeAddress.length > 1 ? (
                        <Grid container>
                          <Grid item xs={12}>
                            <TextField
                              select
                              label={strings.select_address}
                              onChange={this.handleInputChange}
                              margin='normal'
                              value={this.state.address_id}
                              name='address_id'
                              inputProps={{
                                style: {
                                  textAlign:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'right'
                                      : 'unset',
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  left:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'unset'
                                      : 0,
                                  right:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 0
                                      : 'unset',
                                },
                              }}
                              style={{ width: '100%' }}
                            >
                              {this.state.wholeAddress.map((address, index) => (
                                <MenuItem key={index} value={index}>
                                  {address.address}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                        </Grid>
                      ) : null}
                      <Grid container spacing={16}>
                        <Grid item xs={8}>
                          <TextField
                            name='name'
                            id='error'
                            label={strings.street_name}
                            multiline='false'
                            fullWidth
                            margin='normal'
                            onChange={this.handleInputChange}
                            error={this.state.nameError}
                            helperText={this.state.nameErrorMessage}
                            value={this.state.name}
                            className='validate'
                            inputProps={{
                              style: {
                                textAlign:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'right'
                                    : 'unset',
                              },
                            }}
                            InputLabelProps={{
                              className: classes.formLabel,
                              style: {
                                left:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'unset'
                                    : 0,
                                right:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 0
                                    : 'unset',
                              },
                            }}
                            style={{ marginBottom: '10px' }}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            name='buildingNo'
                            id='error'
                            label={strings.building}
                            multiline='false'
                            fullWidth
                            margin='normal'
                            onChange={this.handleInputChange}
                            error={this.state.buildingError}
                            inputProps={{
                              style: {
                                textAlign:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'right'
                                    : 'unset',
                              },
                            }}
                            InputLabelProps={{
                              style: {
                                left:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'unset'
                                    : 0,
                                right:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 0
                                    : 'unset',
                              },
                            }}
                            helperText={this.state.buildingErrorMessage}
                            value={this.state.buildingNo}
                            className='validate'
                            style={{ marginBottom: '10px' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={16}>
                        <Grid item xs={6}>
                          <TextField
                            name='floorNo'
                            id='error'
                            label={strings.floor}
                            multiline='false'
                            fullWidth
                            margin='normal'
                            onChange={this.handleInputChange}
                            inputProps={{
                              style: {
                                textAlign:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'right'
                                    : 'unset',
                              },
                            }}
                            InputLabelProps={{
                              style: {
                                left:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'unset'
                                    : 0,
                                right:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 0
                                    : 'unset',
                              },
                            }}
                            error={this.state.floorError}
                            helperText={this.state.floorErrorMessage}
                            value={this.state.floorNo}
                            className='validate'
                            style={{ marginBottom: '10px' }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            name='appartmentNo'
                            id='error'
                            label={strings.appartment_number}
                            multiline='false'
                            fullWidth
                            margin='normal'
                            onChange={this.handleInputChange}
                            error={this.state.appartmentError}
                            inputProps={{
                              style: {
                                textAlign:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'right'
                                    : 'unset',
                              },
                            }}
                            InputLabelProps={{
                              style: {
                                left:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'unset'
                                    : 0,
                                right:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 0
                                    : 'unset',
                              },
                            }}
                            helperText={this.state.appartmentErrorMessage}
                            value={this.state.appartmentNo}
                            className='validate'
                            style={{ marginBottom: '10px' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={12}>
                          <TextField
                            name='directions'
                            label={strings.directions}
                            multiline='false'
                            fullWidth
                            margin='normal'
                            inputProps={{
                              style: {
                                textAlign:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'right'
                                    : 'unset',
                              },
                            }}
                            InputLabelProps={{
                              style: {
                                left:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 'unset'
                                    : 0,
                                right:
                                  (this.props.lang === 'ar') |
                                  (this.props.lang === 'qrAR')
                                    ? 0
                                    : 'unset',
                              },
                            }}
                            onChange={this.handleInputChange}
                            value={this.state.directions}
                            style={{ marginBottom: '30px' }}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                  <div
                    className='fb-messenger-checkbox'
                    origin=''
                    page_id={pageID}
                    messenger_app_id={messengerAppID}
                    user_ref=''
                    prechecked='true'
                    allow_login='true'
                    size='large'
                  />
                </div>
              </Grid>
            )}
          </Grid>
          {this.state.lastLoading && (
            <div className={classes.successWrapper}>
              <Button
                variant='fab'
                style={{
                  backgroundColor: this.state.success
                    ? '#4caf50'
                    : this.props.color,
                }}
              >
                {this.state.success ? (
                  <CheckIcon style={{ color: '#fff' }} />
                ) : (
                  <RestaurantMenu style={{ color: '#fff' }} />
                )}
              </Button>
              {this.state.loading && (
                <CircularProgress size={68} className={classes.fabProgress} />
              )}
            </div>
          )}
          {/* order grid */}
          <div className={classes.wrapper}>
            <Button
              variant='contained'
              style={{
                backgroundColor: this.state.success
                  ? '#4caf50'
                  : this.props.color,
                border: this.state.success
                  ? '1px solid #4caf50'
                  : `1px solid ${this.props.color}`,
              }}
              classes={{ disabled: classes.disabledButton }}
              disabled={this.state.button_disabled}
              className={classNames(classes.orderNow)}
              onClick={
                this.state.chooseMethod === 'delivery'
                  ? this.validateInput
                  : this.validateInputPickUp
              }
            >
              {strings.order_now}
            </Button>
          </div>
          {/* minimum order  */}
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={this.state.open}
            autoHideDuration={6000}
            onClose={this.handleSnackbarClose}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={
              <span id='message-id'>
                Your Order lower than the minimum: {this.state.minimum}
              </span>
            }
            action={[
              <IconButton
                key='close'
                aria-label='close'
                color='inherit'
                className={classes.close}
                onClick={this.handleSnackbarClose}
              >
                <CloseIcon />
              </IconButton>,
            ]}
          />

          {/* free item minimum order  */}
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open={this.state.freeOpen}
            autoHideDuration={6000}
            onClose={this.handleSnackbarfreeClose}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={
              <span
                id='message-id'
                style={{ position: 'absolute', right: 60, bottom: 20 }}
              >
                عشان تاخد الهدية لازم طلبك يبقى فوق ال
                {this.state.minimum_free_item} جنيه
              </span>
            }
            action={[
              <IconButton
                key='close'
                aria-label='close'
                color='inherit'
                className={classes.close}
                onClick={this.handleSnackbarfreeClose}
              >
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Checkout);



// WEBPACK FOOTER //
// ./src/Checkout.js